<template>
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
    <!-- Top Customers -->
    <div class="bg-white rounded-xl border border-gray-200 p-5">
      <h3 class="text-sm font-semibold text-gray-700">Top Customers</h3>
      <p class="text-xs text-gray-400 mb-4">Top 10 customers ranked by job count</p>
      <apexchart
        v-if="customerSeries[0].data.length"
        type="bar"
        height="300"
        :options="customerChartOptions"
        :series="customerSeries"
      />
      <div v-else class="h-64 flex items-center justify-center text-sm text-gray-400">No data for this period</div>
    </div>

    <!-- Meters by Region -->
    <div class="bg-white rounded-xl border border-gray-200 p-5">
      <h3 class="text-sm font-semibold text-gray-700">Meters by Region</h3>
      <p class="text-xs text-gray-400 mb-4">Total meters tested broken down by region</p>
      <apexchart
        v-if="regionSeries[0].data.length"
        type="bar"
        height="300"
        :options="regionChartOptions"
        :series="regionSeries"
      />
      <div v-else class="h-64 flex items-center justify-center text-sm text-gray-400">No data for this period</div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    customerMetrics: { type: Array, default: () => [] },
    regionMetrics: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  computed: {
    customerSeries() {
      return [{ name: "Jobs", data: this.customerMetrics.map(c => c.jobs) }];
    },
    customerChartOptions() {
      return {
        chart: { toolbar: { show: false } },
        plotOptions: { bar: { horizontal: true, borderRadius: 4, barHeight: "60%" } },
        colors: ["#293a4c"],
        xaxis: {
          categories: this.customerMetrics.map(c => c.company),
          labels: { style: { fontSize: "11px", colors: "#9ca3af" } },
        },
        yaxis: { labels: { style: { fontSize: "11px", colors: "#374151" }, maxWidth: 140 } },
        grid: { borderColor: "#f3f4f6" },
        dataLabels: { enabled: false },
        tooltip: { y: { formatter: (val) => val + " jobs" } },
      };
    },
    regionSeries() {
      return [{ name: "Meters", data: this.regionMetrics.map(r => Math.round(r.meters)) }];
    },
    regionChartOptions() {
      return {
        chart: { toolbar: { show: false } },
        plotOptions: { bar: { borderRadius: 4, columnWidth: "55%" } },
        colors: ["#01BC38"],
        xaxis: {
          categories: this.regionMetrics.map(r => r.region),
          labels: { style: { fontSize: "11px", colors: "#374151" } },
        },
        yaxis: { labels: { style: { fontSize: "11px", colors: "#9ca3af" } } },
        grid: { borderColor: "#f3f4f6" },
        dataLabels: { enabled: false },
        tooltip: { y: { formatter: (val) => val.toLocaleString() + " meters" } },
      };
    },
  },
};
</script>
